/**
 * Fleet Service Record API
 *
 * Fleet-portal (CLIENT user) vehicle service history.
 *
 * SCOPING: no call sends a customer id. The backend resolves the fleet customer
 * from the `customerUuid` JWT claim and scopes every read to it — on the customer
 * FK, not on a name match.
 *
 * IMAGES: unlike the workshop API there is no image-url endpoint. The workshop's
 * presigns any S3 key beginning `job/`, which would let a fleet user pull any job
 * image in the workshop. Note images are instead presigned server-side and arrive
 * inside the detail response as `noteImageUrls` (s3Key → URL).
 */

import axiosInstance from './axiosInstance';

const BASE = '/fleet/service-records';

/**
 * Paginated service history for a date range, newest first.
 *
 * Both `from` and `to` are required (YYYY-MM-DD, inclusive). Unlike the workshop
 * search there is no text filter and no same-month constraint.
 *
 * @param {{ from: string, to: string, page?: number, size?: number }} params
 * @returns {Promise<{ content: Array, totalPages: number, totalElements: number, number: number, size: number }>}
 */
export const listFleetServiceRecordsApi = async ({ from, to, page = 0, size = 20 }) => {
    const response = await axiosInstance.get(BASE, {
        params: { from, to, page, size },
    });
    return response.data;
};

/**
 * Full service record by id — work items, measurements, notes, and presigned
 * note-image URLs.
 *
 * @param {number} id VehicleServiceRecord PK
 */
export const getFleetServiceRecordApi = async (id) => {
    const response = await axiosInstance.get(`${BASE}/${id}`);
    return response.data;
};

const fleetServiceRecordMgtApi = {
    listFleetServiceRecordsApi,
    getFleetServiceRecordApi,
};

export default fleetServiceRecordMgtApi;